module.exports = __webpack_public_path__ + "static/media/logo.e7ac0e87.png";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/EnquiryPage/logo.png
// module id = 1039
// module chunks = 0